import { combineReducers } from "redux";
import { entities as brands } from "./brandData";
import { entities as dataSpeedGens } from "./dataSpeedGenData";
import { entities as offerExtraGroups } from "./offerExtraGroupData";
import { entities as offerExtras } from "./offerExtraData";
import { entities as phoneCategories } from "./phoneCategoryData";
import { entities as phoneOffers } from "./phoneOfferData";
import { entities as phoneOperatingSystems } from "./phoneOperatingSystemData";
import { entities as phoneStates } from "./phoneStateData";
import { entities as phoneVariants } from "./phoneVariantData";
import { entities as phones } from "./phoneData";
import { entities as propositions } from "./propositionData";
import { entities as providers } from "./providerData";
import { entities as shops } from "./shopData";
import { entities as simOnlyOffers } from "./simOnlyOfferData";
import { entities as sponsoredPositions } from "./sponsoredPositionData";

const entities = combineReducers({
  brands,
  dataSpeedGens,
  offerExtraGroups,
  offerExtras,
  phoneCategories,
  phoneOffers,
  phoneOperatingSystems,
  phoneStates,
  phoneVariants,
  phones,
  propositions,
  providers,
  shops,
  simOnlyOffers,
  sponsoredPositions
});

export default entities;
